import { render, staticRenderFns } from "./PhotoEditor.vue?vue&type=template&id=21f43a33&scoped=true"
import script from "./PhotoEditor.vue?vue&type=script&lang=js"
export * from "./PhotoEditor.vue?vue&type=script&lang=js"
import style0 from "./PhotoEditor.vue?vue&type=style&index=0&id=21f43a33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f43a33",
  null
  
)

export default component.exports